import { render, staticRenderFns } from "./EmeContactDetail.vue?vue&type=template&id=20470fa5"
import script from "./EmeContactDetail.vue?vue&type=script&lang=js"
export * from "./EmeContactDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20470fa5')) {
      api.createRecord('20470fa5', component.options)
    } else {
      api.reload('20470fa5', component.options)
    }
    module.hot.accept("./EmeContactDetail.vue?vue&type=template&id=20470fa5", function () {
      api.rerender('20470fa5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/eme/EmeContactDetail.vue"
export default component.exports